// sessionStorage key for the post-login destination (the MSAL `state` = the ?returnTo deep link). Set by
// IdentityConfigLoader when it consumes the redirect response, read + cleared by AuthCallbackPage — because
// processing the redirect there (to suppress MSAL's navigate-back) fires ACQUIRE_TOKEN_SUCCESS before
// AuthCallbackPage can subscribe, so the deep link is handed off via storage instead of the event.
export const POST_LOGIN_DEST_KEY = 'lsk.postLoginDest'

// E8 F8-2: sanitise a post-login return target to a SAME-ORIGIN relative path. The value flows from a
// user-controllable source (the ?returnTo query param, or the MSAL `state` echoed back after the redirect)
// into client navigation, so an unvalidated absolute URL would be an open redirect
// (e.g. ?returnTo=https://evil.com/phish). Returns a path beginning with '/' (pathname + search + hash)
// when the value resolves to this origin; otherwise null (caller falls back to a safe default).
export function toSafeInternalPath(value: string | null | undefined): string | null {
  if (!value) {
    return null
  }

  try {
    // Resolve relative ('/dashboard') and absolute ('https://acme.logikspark.ai/x') forms against the
    // current origin. Protocol-relative ('//evil.com'), cross-origin and opaque ('javascript:') values
    // all resolve to a different/opaque origin and are rejected.
    const url = new URL(value, window.location.origin)
    if (url.origin !== window.location.origin) {
      return null
    }
    const path = `${url.pathname}${url.search}${url.hash}`
    return path.startsWith('/') ? path : null
  } catch {
    return null
  }
}
